<template>
  <section class="section">
    <div class="container">
        <p class="title">
          Gymnasts
        </p>
        <p class="subtitle">
          Configuire gymnasts and set thier current conditioning level
        </p>
        <div class="container">
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Edit</th>
                <th>Arms</th>
                <th>Legs</th>
                <th>Stomach</th>
                <th>Back</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <gymnast-row 
                v-for="gymnast in gymnasts" 
                :key="gymnast.name"
                :gymnast="gymnast"
                @update:gymnast="val => { updateGymnast(gymnast, val) }"
                @update:remove="val => { removeGymnast(gymnast) }">
              </gymnast-row>
            </tbody>
          </table>
          <div class="field has-addons" v-if="addingGymnast">
            <div class="control">
              <input class="input" type="text" placeholder="Full Name" v-model="newGymnastInput">
            </div>
            <div class="control">
              <a class="button is-info" @click="addGymnast">
                Add
              </a>
            </div>
          </div>
          <a v-show="!addingGymnast" class="button" @click="toggleAdding">
            <span class="icon">
              <i class="fas fa-user-plus"></i>
            </span>
            <span>Add Gymnast</span>
          </a>
        </div>
      </div>
      <div class="modal" :class="deleteModal">>
        <div class="modal-background"></div>
        <div class="modal-card">
          <section class="modal-card-body">
            <p>You sure you want to delete this gymnast? You will lose all level data.</p>
          </section>
          <footer class="modal-card-foot">
            <button class="is-danger button" @click="confirmDeletion">
              Delete
            </button>
            <button class="button" @click="deleting = false">
              Just Joking
            </button>
          </footer>
        </div>
        <button class="modal-close is-large" aria-label="close"></button>
      </div>
    </section>
</template>

<script>
import GymnastRow from '@/components/TableGymnastRow'
import {db} from '@/firebase'

export default {
  name: 'GymnastsEdit',
  data () {
    return {
      addingGymnast: false,
      newGymnastInput: '',
      gymnasts: [],
      deleting: false,
      choppingBlock: null
    }
  },
  firebase: {
    gymnasts: {
      source: db.ref('gymnasts')
    }
  },
  components: {
    GymnastRow
  },
  methods: {
    toggleAdding () {
      this.addingGymnast = !this.addingGymnast
    },
    updateGymnast (gymnast, newGymnast) {
      let key = gymnast['.key']
      this.$firebaseRefs.gymnasts.child(gymnast['.key']).set({
        name: newGymnast.name,
        arms: newGymnast.arms,
        legs: newGymnast.legs,
        stomach: newGymnast.stomach,
        back: newGymnast.back
      })
    },
    addGymnast () {
      this.$firebaseRefs.gymnasts.push({
        name: this.newGymnastInput,
        arms: 1,
        legs: 1,
        back: 1,
        stomach: 1
      })
      this.newGymnastInput = ''
      this.addingGymnast = false
    },
    removeGymnast (gymnast) {
      this.deleting = true
      this.choppingBlock = gymnast
    },
    confirmDeletion () {
      this.$firebaseRefs.gymnasts.child(this.choppingBlock['.key']).remove()
      this.choppingBlock = null
      this.deleting = false
    }
  },
  computed: {
    deleteModal () {
      if(this.deleting) return 'is-active'
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/GymnastsEdit.vue